module.exports = __webpack_public_path__ + "static/media/jialefu.05cd574c.png";